export default __webpack_public_path__ + "static/media/er3.718b3f0e.jpg";